export const ROLE_DETAILS_USERS_TITLE = "Members:roleId";

export const linkToRoleUsersPage = (roleId = ":roleId") =>
  `/app/settings/roles-and-permissions/roles/${roleId}/detail?tab=members`;

export const ROLE_DETAILS_USERS_BREADCRUMB = {
  title: ROLE_DETAILS_USERS_TITLE,
  path: linkToRoleUsersPage,
};
